export * from './ImagePlaceholder'
export * from './FileUploadIcon'
export * from './DuplicateIcon'


// WEBPACK FOOTER //
// ./src/shared/components/ui/icons/index.tsx